import * as React from 'react';

type Props = {
    Agreement: AgreementViewModel;
    index: number;
    Validation: boolean;
}

type State = {
    Checked: boolean;
}

export type AgreementViewModel = {
    Title: string;
    Body: string;
}

export default class RegistrationAgreement extends React.Component<Props, State> {

    constructor(props:Props){
        super(props);

        this.state = {
            Checked: false,
        }

        this.check = this.check.bind(this);
    }

    public render() {
        return <React.Fragment>
            <div className="k-form-field">
                <input type="checkbox" id={`agreement${this.props.index}`} className="k-checkbox" onClick={this.check} />
                <label className="k-checkbox-label" htmlFor={`agreement${this.props.index}`} style={{fontSize: 18, marginLeft: 10}}>I Agree to the <button type="button" className="btn-link" style={{border: 0, fontSize: 18, outline: 0, padding: 0, marginLeft: 5}} data-toggle="modal" data-target={".agreement-" + this.props.index}>{this.props.Agreement.Title}</button><div style={{ color: '#dc3545' }}>*</div></label>
                <div className={"modal fade agreement-" + this.props.index} tabIndex={-1} role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title font-weight-bold">{this.props.Agreement.Title}</h4>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body" dangerouslySetInnerHTML={{ __html: this.props.Agreement.Body }} />
                        </div>
                    </div>
                </div>
            </div>
            {this.props.Validation && !this.state.Checked ? <p className="error-msg">You must Agree to {this.props.Agreement.Title}</p> : <br/>}
        </React.Fragment>
    }

    check() {
        this.setState({
            Checked: !this.state.Checked
        });
    }
}
